// extracted by mini-css-extract-plugin
export default {"wrapper":"Terms_wrapper__oN56J","button":"Terms_button__gGCtc","content":"Terms_content__LNxKp"};